import {
  Alert,
  Box,
  Snackbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export type FeedbackToastState = {
  open: boolean;
  type: "success" | "error" | "warning" | "info";
  title?: string;
  message: string;
};

type Props = FeedbackToastState & {
  onClose: () => void;
};

export default function FeedbackToast({
  open,
  type,
  title,
  message,
  onClose,
}: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const icon =
    type === "success" ? (
      <CheckCircleOutlineIcon fontSize="large" />
    ) : type === "error" ? (
      <ErrorOutlineIcon fontSize="large" />
    ) : undefined;

  return (
    <Snackbar
      open={open}
      autoHideDuration={4500}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{
        top: isMobile ? "35% !important" : "28% !important",
        left: "50% !important",
        right: "auto !important",
        transform: "translateX(-50%)",
        width: { xs: "calc(100% - 32px)", sm: 420 },
      }}
    >
      <Alert
        severity={type}
        variant="filled"
        icon={icon}
        onClose={onClose}
        sx={{
          width: "100%",
          borderRadius: 3,
          boxShadow: 8,
          alignItems: "center",
          py: 1.5,
          px: 2,
        }}
      >
        {title && (
          <Typography fontWeight={900} sx={{ mb: 0.25 }}>
            {title}
          </Typography>
        )}
        <Typography variant="body2">{message}</Typography>
      </Alert>
    </Snackbar>
  );
}